//@import dependencies
import React, {useEffect, useState} from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AlertComponent from 'app_components/commons/alert'
import DataTableComponent from 'app_components/commons/dataTable'
import QualificationsSkeleton from './qualificationsSkeleton'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../qualificationsModule.scss'
import QualifiedTeacherService from 'app_services/admin/qualifiedTeacher/qualifiedTeacherService'
import { useSelector } from 'react-redux';
import { CombinedReducers } from 'app_events/index';
import { QualifiedTeacher } from 'app_types/admin/qualifiedTeacher/qualifiedTeacherTypes'
import moment from 'moment';

// @ADD Component types
interface IQualificationsModuleLayoutProps {
  status: null | 'loading' | 'error'
  qualificationData: Array<any>
}

const QualificationsModuleLayout: React.FC<IQualificationsModuleLayoutProps> = (props) => {

  const { t } = useTranslation()
  const [teachers, updateTeachers] = useState<QualifiedTeacher[]>([]);
  const user = useSelector((store: CombinedReducers) => store.auth?.user?.data);

  const qualifiedTeacherService = new QualifiedTeacherService();

  useEffect(() => {
    getCourses();
  }, []);

  const getCourses = async () => {
    if (!user?.id) return
    const teachersResponse: any = await qualifiedTeacherService.listQualifiedTeachers({
      teacher: user.id,
      statuses: ['ACTIVO', 'active']
    })
    if (teachersResponse?.qualifiedTeachers) {
      let _qualifiedTeachers: any[] = teachersResponse.qualifiedTeachers;
      if (_qualifiedTeachers) {
        _qualifiedTeachers.sort((a,b) => a.courseCode - b.courseCode);
        updateTeachers(_qualifiedTeachers);
      }
    }
  }

  return(
    <div className='qualification_module-component'>
      <div className="title">
        {t("modules.qualification_module.title")}
      </div>
      <hr />
      <div className="table-format-standar main-table container-table-qualifications">
        {props.status === 'loading' ? (
          <QualificationsSkeleton />
        ): (
          <>
          {teachers && Array.isArray(teachers) && teachers.length > 0 ? (
            <>
              <DataTableComponent
                data={teachers}
                headerKeys={[
                  `${t('modules.qualification_module.headers.code')}`,
                  `${t('modules.qualification_module.headers.name')}`,
                  `${t('modules.qualification_module.headers.date')}`
                ]}
                keys={['courseCode', 'courseName']}
                detailsKey={[]}
                onModal={null}
                hideTooltip
                rowButtons={(teacher: QualifiedTeacher) => (
                  <div>
                    {moment(teacher.evaluationDate).format('YYYY/MM/DD').includes('1969') ? '-' : moment(teacher.evaluationDate).format('YYYY/MM/DD')}
                  </div>
                )}
              />
            </>
          ): (
            <AlertComponent
              type='warning'
              title={t('modules.qualification_module.no_data')}
            />
          )}
          </>
        )}
      </div>
    </div>
  )
}

export default QualificationsModuleLayout
